// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.grade-project-page {
  font-family: Arial, sans-serif;
  padding: 20px;
  background-color: #f0f9ff;
}

.grade-project-page h1 {
  text-align: center;
  color: #1e90ff;
  margin-bottom: 20px;
}

.student-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin: 0 auto;
  max-width: 900px;
}
.student-search-bar {
  width: 100%;
  max-width: 300px;
  padding: 8px;
  margin: 20px 80;
  border-radius: 5px;
  border: 1px solid #ccc;
  font-size: 16px;
  align-items: center;
  margin-left: 600px;
}


.student-row {
  display: flex;
  flex-direction: column;
  gap: 10px;
  background-color: #d4f1f9;
  padding: 15px;
  border-radius: 8px;
}

.student-name {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
}

.project-inputs {
  display: flex;
  gap: 10px;
  align-items: center;
}

.project-inputs select,
.project-inputs input[type="number"] {
  padding: 5px;
  border-radius: 5px;
  border: 1px solid #ccc;
}

.project-inputs a {
  text-decoration: none;
  color: #1e90ff;
  padding: 5px;
}

.project-inputs span {
  font-weight: bold;
}

button {
  background-color: #1e90ff;
  color: white;
  border: none;
  padding: 8px 12px;
  border-radius: 5px;
  cursor: pointer;
  margin-top: 10px;
}

button:hover {
  background-color: #005bb5;
}
`, "",{"version":3,"sources":["webpack://./src/MyComponents/Actions/GradeProjectPage.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,yBAAyB;EACzB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".grade-project-page {\n  font-family: Arial, sans-serif;\n  padding: 20px;\n  background-color: #f0f9ff;\n}\n\n.grade-project-page h1 {\n  text-align: center;\n  color: #1e90ff;\n  margin-bottom: 20px;\n}\n\n.student-list {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  margin: 0 auto;\n  max-width: 900px;\n}\n.student-search-bar {\n  width: 100%;\n  max-width: 300px;\n  padding: 8px;\n  margin: 20px 80;\n  border-radius: 5px;\n  border: 1px solid #ccc;\n  font-size: 16px;\n  align-items: center;\n  margin-left: 600px;\n}\n\n\n.student-row {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  background-color: #d4f1f9;\n  padding: 15px;\n  border-radius: 8px;\n}\n\n.student-name {\n  font-size: 18px;\n  font-weight: bold;\n  margin-bottom: 10px;\n}\n\n.project-inputs {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n\n.project-inputs select,\n.project-inputs input[type=\"number\"] {\n  padding: 5px;\n  border-radius: 5px;\n  border: 1px solid #ccc;\n}\n\n.project-inputs a {\n  text-decoration: none;\n  color: #1e90ff;\n  padding: 5px;\n}\n\n.project-inputs span {\n  font-weight: bold;\n}\n\nbutton {\n  background-color: #1e90ff;\n  color: white;\n  border: none;\n  padding: 8px 12px;\n  border-radius: 5px;\n  cursor: pointer;\n  margin-top: 10px;\n}\n\nbutton:hover {\n  background-color: #005bb5;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
